import Raven from 'raven-js';
import config from 'config.json';
Raven.config(config.raven, {
  environment: config.environment,
  release: process.env.VERSION,
  ignoreUrls: [/localhost/]
}).install();
export default Raven;
